import apiClient from '../api/client';

// Example of creating a suggestion
export const createSuggestion = async (accessCode, suggestionData) => {
  try {
    const response = await apiClient.post(
      `/assessment/${accessCode}/improvement_suggestions`,
      { suggestion: suggestionData }
    );
    return response;
  } catch (error) {
    console.error('Error creating suggestion:', error);
    throw error;
  }
};

export const updateSuggestion = async (accessCode, id, suggestionData) => {
  try {
    const response = await apiClient.patch(
      `/assessment/${accessCode}/improvement_suggestions/${id}`,
      { suggestion: suggestionData }
    );
    return response;
  } catch (error) {
    console.error('Error updating suggestion:', error);
    throw error;
  }
};

export const deleteSuggestion = async (accessCode, id) => {
  try {
    await apiClient.delete(
      `/assessment/${accessCode}/improvement_suggestions/${id}`
    );
  } catch (error) {
    console.error('Error deleting suggestion:', error);
    throw error;
  }
};

export const getSuggestions = async (accessCode, { factorId, contributorId } = {}) => {
  try {
    let url = `/assessment/${accessCode}/improvement_suggestions`;
    if (factorId) url += `?factor_id=${factorId}`;
    else if (contributorId) url += `?contributor_id=${contributorId}`;
    
    const response = await apiClient.get(url);
    return response;
  } catch (error) {
    console.error('Error fetching suggestions:', error);
    throw error;
  }
}; 